import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const getResponse = async (setResponse, setLoading, estateId) => {
  try {
    const result = await http.get(AUTH_ROUTES.GET_MESSAGE(estateId));
    setResponse(result?.data?.details?.data);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.log(e?.response, "Message error");
    errorNotifier(
      e?.response?.data?.data ||
      e?.response?.data?.message ||
      "Failed to load messages."
    );
  }
};

export const deleteMessage = async (payload, msgId, setRefresh, setLoading) => {
  try {
    await http.delete(AUTH_ROUTES.DELETE_MESSAGE(msgId), { data: payload });
    setLoading(false);
    successNotifier("Message successfully deleted");
    setRefresh((prev) => !prev);
  } catch (e) {
    console.log(e?.response, "error deleting message");
    setLoading(false);
    errorNotifier(
      e?.response?.data?.data ||
      e?.response?.data?.message ||
      "Failed to delete message."
    );
  }
};

export const sendUserResponse = async (
  ticketId,
  payload,
  setLoading,
  setRefresh,
) => {
  try {
    await http.post(AUTH_ROUTES.USER_SEND_RESPONSE(ticketId), payload);
    setLoading(false);
    setRefresh((prev) => !prev);
    successNotifier("Reply sent");
  } catch (e) {
    setLoading(false);
    errorNotifier(e?.response?.data?.data || "Could not send reply");
  }
};
